import React, {useState} from "react";
import {Switch} from '@material-ui/core';
import {Stack, Typography} from "@mui/material";
import { useTheme } from "@material-ui/styles"
import { switchStyles } from "../../utils"

export default function LabeledSwitch({
                                          labelEnd = false,
                                          labelBegin = false,
                                          labelVertical = false,
                                          labelPlacementBegin = true,
                                          labelPlacementEnd = true,
                                          handleChange,
                                          defaultChecked = false,
                                          labelBeginClass = '',
                                          labelEndStyle = '',
                                          switchClass = '',
                                          color = 'primary',
                                          isContrast
                                      }) {
    const {theme: {bgColors, colors}} = useTheme()
    const [checked, setChecked] = useState(defaultChecked);
    const switchClasses = switchStyles(bgColors, colors)()
    const handleClickSwitch = () => {
        handleChange(!checked);
        setChecked(!checked);
    }
    const direction = labelVertical ? "column" : "row";
    return (
        <Stack direction={direction} alignItems="center">
            {labelPlacementBegin &&
                <Typography className={labelBeginClass} style={{cursor: "pointer"}}
                            onClick={handleClickSwitch}>{labelBegin}</Typography>}
            <Switch

                onClick={handleClickSwitch}
                className={`${switchClass} ${isContrast ? switchClasses.root : ''}`}
                checked={checked}
                color={color}
            />
            {labelPlacementEnd &&
                <Typography style={{cursor: "pointer", ...labelEndStyle}}
                            onClick={handleClickSwitch}>{labelEnd}</Typography>}
        </Stack>
    );
}


